import { type FanTokenOfferingCostEstimate } from '@capsicum/common';
import { atom, useAtom } from 'jotai';

const paymentCurrencyIdAtom = atom<string>('');
const fanTokenShortCodeAtom = atom<string>('');

const offeringCostEstimateAnswerAtom = atom<FanTokenOfferingCostEstimate['payload']>(
	{} as FanTokenOfferingCostEstimate['payload']
);

export const usePurchaseFTODataAtom = () => {
	const [paymentCurrencyId, setPaymentCurrencyId] = useAtom(paymentCurrencyIdAtom);
	const [offeringCostEstimateAnswer, setOfferingCostEstimateAnswer] = useAtom(offeringCostEstimateAnswerAtom);
	const [fanTokenShortCode, setFanTokenShortCode] = useAtom(fanTokenShortCodeAtom);

	return {
		fanTokenShortCode,
		offeringCostEstimateAnswer,
		paymentCurrencyId,
		setFanTokenShortCode,
		setOfferingCostEstimateAnswer,
		setPaymentCurrencyId
	};
};
